import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { getThaid } from 'src/app/core/view-models/login';

@Component({
  selector: 'app-thaid-callback',
  templateUrl: './thaid-callback.component.html',
  styleUrls: ['./thaid-callback.component.scss']
})
export class ThaidCallbackComponent implements OnInit {

  pid: string = '';
  given_name: string = '';
  family_name: string = '';
  birthdate: string = '';
  hasRegistered: boolean = false;
  code: string = '';
  id: string = '';
  accessToken: string = '';
  refreshToken: string = '';
  expiresIn: number = 0;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        const code = params["code"];
        if (code != undefined && code != "") {
          this.loginByThaid(code);
        }else{
          this.router.navigate(['/login'])
        }
      });
  }

  async loginByThaid(code: string) {
    const result = await this.authService.getLoginByThaid(code)

    if (result) {
      this.pid = result.pid;
      this.given_name = result.given_name;
      this.family_name = result.family_name;
      this.birthdate = result.birthdate;
      this.hasRegistered = result.hasRegistered;
      this.code = code;
      this.id = result.pid;
      this.accessToken = result.accessToken;
      this.expiresIn = result.expiresIn;
      this.refreshToken = result.refreshToken;

      if (this.hasRegistered == true) {
        this.loginByAccessToken(this.accessToken);

      } else {
        this.router.navigate(['/register'], {
          queryParams:
            { f_thaid: "Y" }
        })
      }
    } else {
      this.router.navigate(['/login'])
    }
  }

  async loginByAccessToken(accessToken: string) {
    const result = await this.authService.loginByAccessToken(accessToken)
    if (result) {
      this.router.navigate(['/home'])
    }
  }

}
